<template lang="pug">
  #dashboard-chart-filters
    .is-flex
      .p-1
        .label.has-text-grey.is-size-7.pl-2 Category
        BSelect(
          v-model="metricIndex"
          :loading="dataLoading"
        )
          option(
            v-for="(option, index) in metrics"
            :value="index"
            :key="option"
          ) {{ _.upperFirst(option) }}
      .p-1
        .label.has-text-grey.is-size-7.pl-2 Time Frame
        BSelect(
          v-model="timeFrameIndex"
          :loading="dataLoading"
        )
          option(
            v-for="(option, index) in timeFrame"
            :value="index"
            :key="option.label"
          ) {{ option.label }}
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DashboardChartFilters",

  props: {
    daysInChart: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      timeFrameIndex: 0,
      timeFrame: [
        { label: "Week", days: 7 },
        { label: "Month", days: 30 },
        { label: "3 Months", days: 90 }
      ],
      metricIndex: 0,
      dataLoading: false
    };
  },

  computed: {
    ...mapGetters("program", ["isCoreTier"]),

    metricTypeSteps() {
      return this.metricType.includes("steps");
    },

    metricTypeWellness() {
      return !this.metricType.includes("steps");
    },

    metricType() {
      return this.metricList[this.metricIndex];
    },

    metricList() {
      return [
        "steps & Activities",
        "nutrition",
        "water",
        "mood",
        "sleep",
        "heart",
        "mindfulness",
        "weight"
      ];
    },

    isWellnessMetricsOn() {
      return this.$auth.user().program.isWellnessMetricsOn;
    },

    metrics() {
      if (this.isWellnessMetricsOn) {
        return this.metricList;
      } else {
        return [this.metricList[0]];
      }
    }
  },

  watch: {
    timeFrameIndex() {
      this.fetchData();
    },
    metricIndex() {
      this.$emit("set-metric-type", this.metrics[this.metricIndex]);
      this.fetchData();
    }
  },

  methods: {
    ...mapActions("members", [
      "fetchMemberStepData",
      "fetchMemberWellnessData"
    ]),

    fetchData() {
      this.dataLoading = true;
      let days = this.timeFrame[this.timeFrameIndex].days;
      let payload;

      // clear chartData so chart re-renders
      this.$emit("clear-chart-data", {});
      // setting days here will place the dates across the bottom of the chart
      this.$emit("set-days-in-chart", days);

      if (this.metricTypeSteps) {
        payload = {
          memberId: this.$auth.user().id,
          perPage: days
        };

        return this.fetchMemberStepData(payload).then(() => {
          this.dataLoading = false;
        });
      }
      if (this.metricTypeWellness) {
        payload = {
          memberId: this.$auth.user().id,
          days,
          metric: this.metricType
        };

        return this.fetchMemberWellnessData(payload).then(() => {
          this.dataLoading = false;
        });
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
